import {
  previewSettlement,
  previewDebtList,
  getWriterUnsettledDetails,
  getWriterPaymentInfo,
  createSettlementBatches,
  listSettlementBatches,
  getBatchDetail,
  auditBatch
} from '@/api/settlement'

export const BATCH_STATUS = {
  PENDING: 0, AUDITED: 1, PAID: 2, REJECTED: 3
}

export const BATCH_STATUS_TEXT = {
  0: '待审核', 1: '已审核', 2: '已打款', 3: '已驳回'
}

export const BATCH_STATUS_TYPE = {
  0: 'warning', 1: 'primary', 2: 'success', 3: 'danger'
}

export const PAY_CHANNELS = [
  { label: '银行卡', value: 'BankCard' },
  { label: '微信', value: 'Wechat' },
  { label: '支付宝', value: 'Alipay' },
  { label: 'Paypal', value: 'Paypal' }
]

const state = {
  previewSummary: { writer_count: 0, total_amount: 0, debt_writer_count: 0 },
  previewList: [],
  debtList: [],
  batchList: [],
  batchTotal: 0,
  currentBatch: null,
  currentBatchDetails: [],
  currentWriterDetails: [],
  currentWriterPaymentInfo: null
}

const mutations = {
  SET_PREVIEW(state, { summary, list }) {
    state.previewSummary = summary
    state.previewList = list || []
  },
  SET_DEBT_LIST(state, list) {
    state.debtList = list || []
  },
  SET_BATCH_LIST(state, { list, total }) {
    state.batchList = list || []
    state.batchTotal = total || 0
  },
  SET_CURRENT_BATCH(state, { batch, details }) {
    state.currentBatch = batch
    state.currentBatchDetails = details || []
  },
  CLEAR_CURRENT_BATCH(state) {
    state.currentBatch = null
    state.currentBatchDetails = []
  },
  SET_CURRENT_WRITER_DETAILS(state, details) {
    state.currentWriterDetails = details || []
  },
  SET_CURRENT_WRITER_PAYMENT_INFO(state, info) {
    state.currentWriterPaymentInfo = info
  }
}

const actions = {
  async fetchPreview({ commit }) {
    const res = await previewSettlement()
    commit('SET_PREVIEW', res.data || { summary: {}, list: [] })
    return res.data
  },

  async fetchDebtList({ commit }) {
    const res = await previewDebtList()
    commit('SET_DEBT_LIST', res.data)
    return res.data
  },

  async fetchWriterDetails({ commit }, payload) {
    const writer_id = typeof payload === 'object' ? payload.writer_id : payload
    const settlement_type = typeof payload === 'object' ? payload.settlement_type : undefined
    const res = await getWriterUnsettledDetails(writer_id, settlement_type)
    commit('SET_CURRENT_WRITER_DETAILS', res.data)
    return res.data
  },

  async fetchWriterPaymentInfo({ commit }, writer_id) {
    const res = await getWriterPaymentInfo(writer_id)
    commit('SET_CURRENT_WRITER_PAYMENT_INFO', res.data)
    return res.data
  },

  async createBatches(_, { writer_id, detail_ids }) {
    const res = await createSettlementBatches(writer_id, detail_ids)
    return res.data
  },

  async fetchBatchList({ commit }, params = {}) {
    const res = await listSettlementBatches(params)
    commit('SET_BATCH_LIST', {
      list: res.data?.list,
      total: res.data?.total
    })
    return res.data
  },

  async fetchBatchDetail({ commit }, id) {
    const res = await getBatchDetail(id)
    commit('SET_CURRENT_BATCH', res.data || {})
    return res.data
  },

  async auditBatch(_, payload) {
    const res = await auditBatch(payload)   // 这里调用的是 import 的 API
    return res.data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}